<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <h1 class="modal-title">
        {{ title }}
      </h1>
      <span v-if="form.firstName && form.lastName">
        <text-field v-model.trim="form.firstName" label="First Name" type="text" disabled />
        <text-field v-model.trim="form.lastName" label="Last Name" type="text" disabled />
      </span>
      <text-field
        v-model.trim="form.email"
        :validator="vs.form.email"
        :disabled="type !== 'CREATE'"
        label="E-mail"
        type="text"
      />
      <select-field
        v-model="form.role"
        :items="roles"
        :validator="vs.form.role"
        :disabled="type === 'SENT' || type === 'RESEND'"
        label="Role"
        item-render="display"
        item-select="value"
      />
      <div class="buttons">
        <main-button
          v-if="type !== 'CREATE'"
          class="delete-button"
          color="error"
          flat
          :text="'DELETE'"
          @click="$emit('delete')"
        />
        <div class="buttons-right">
          <main-button class="back-btn" flat :text="'CANCEL'" @click="$emit('closeModal')" />
          <main-button
            v-if="type !== 'SENT'"
            class="continue-btn"
            depressed
            @click="$emit('submit')"
          >
            <span>{{ buttonTitle }}</span>
          </main-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-user-modal',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    forCreate: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'CREATE',
    },
  },
  data() {
    return {
      form: this.initialValues,
      title:
        this.type === 'CREATE'
          ? 'Invite new event worker'
          : this.type === 'UPDATE'
          ? 'Update workers role'
          : this.type === 'EXPIRED'
          ? 'Invite expired'
          : 'Invite sent',
      buttonTitle: this.type === 'CREATE' ? 'invite' : this.type === 'UPDATE' ? 'update' : 'resend',
      roles: [
        {
          display: 'Printer',
          value: 'PRINTER',
        },
        {
          display: 'Editor',
          value: 'EDITOR',
        },
      ],
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 2rem;
}
.buttons {
  display: flex;
  align-items: center;
}
.buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
